import $ from '@sv/jquery';
import { doGetWithFade } from '../../util/portletUtil';
import { updatePaging } from '../shared/commonSearchFunction';
import { updateSearchUrlParams } from '../shared/updateSearchUrlParams';

export const initFacetedSearch = () => {
  const $portlets = $('.sv-facetedsearch-portlet');
  const $forms = $portlets.find('form');

  if ($forms.length) {
    if ($forms.data('fnUseInstantSearch') !== undefined) {
      const $searchBox = $forms.find('input[name=query]');
      $searchBox.data('fnQueryLength', 0);
      let previousQueryLength = 0;

      $searchBox.on('input', (e) => {
        const $searchBox = $(e.target);
        const query = $searchBox.val();
        const queryLength = query.length;
        $searchBox.data('fnQueryLength', queryLength);

        const $form = $searchBox.closest('form');
        const targetId = $form.data('fnResultContainer');
        const $target = $(targetId);

        if (queryLength === 0) {
          previousQueryLength = 0;
          $target.html('');
          updateSearchUrlParams('query=', 'query');
        } else if (queryLength > 1 || queryLength < previousQueryLength) {
          const encodedQry = encodeURIComponent(query);
          const timeoutName = `${targetId.substring(1)}Timeout`;
          previousQueryLength = queryLength;

          if (window[timeoutName]) {
            window.clearTimeout(window[timeoutName]);
          }

          window[timeoutName] = window.setTimeout(() => {
            updateSearchUrlParams(`query=${encodedQry}`, 'query');
            const url = $form.data('fnBaseUrl') + query;
            doGetWithFade($target, url, updatePaging);
          }, 500);
        }
        return false;
      });
    }
  }
  $portlets.on(
    'click',
    '[data-fn-search-facet], [data-fn-search-sort]',
    (e) => {
      e.preventDefault();
      const $target = $(e.target).closest(
        '[data-fn-search-facet], [data-fn-search-sort]'
      );
      const resultId = $target
        .closest('.sv-portlet')
        .children('form')
        .data('fnResultContainer');
      const facetUrl = $target.data('fnSearchFacet');
      const sortUrl = $target.data('fnSearchSort');
      const url = facetUrl || sortUrl;
      updateSearchUrlParams(url, 'refinement');

      doGetWithFade($(resultId), url, (...args) => {
        updatePaging(...args);
      });
      return false;
    }
  );
};
